import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("zx_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const SESSION_EXPIRED_EVENT = "zx:session-expired";
export const DEFAULT_EXPIRED_MSG = "Sessione scaduta, effettua di nuovo il login.";

api.interceptors.response.use(
  (res) => res,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || "";
    if (status === 401 && !url.startsWith("/auth/") && localStorage.getItem("zx_token")) {
      const detail = error.response?.data?.detail;
      window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT, {
        detail: typeof detail === "string" ? detail : DEFAULT_EXPIRED_MSG,
      }));
    }
    return Promise.reject(error);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
